import {
	fetchAccessState,
	fetchBlockStatuses,
	fetchEncryptedPrivate,
	fetchPurchaseSummary,
	isAuthenticated$,
	unwrapThunk,
	unwrapThunks,
} from '@op/services'
import type { OPResolver } from '../common'
import { createResolverRedirect, resolveSerial } from '../common'
import { setRedirect } from '../reducers/landing.slice'
import { accountGenArgs } from '../util/crypto'

const isAuthenticatedResolver = (async (store, location) => {
	const isAuth = isAuthenticated$(store.getState())

	if (!isAuth) {
		/** @see resolveSerial */
		await Promise.resolve()
		store.dispatch(setRedirect(location.pathname))
		throw createResolverRedirect('/login')
	}
}) satisfies OPResolver

const rootStateResolver = (async (store) => {
	unwrapThunk(store.dispatch(fetchPurchaseSummary()))
	unwrapThunk(store.dispatch(fetchEncryptedPrivate(accountGenArgs())))

	await Promise.all(
		unwrapThunks([store.dispatch(fetchAccessState()), store.dispatch(fetchBlockStatuses())]),
	)
}) satisfies OPResolver

export const resolveSerialRootAuth = resolveSerial.bind(
	null,
	isAuthenticatedResolver,
	rootStateResolver,
)
